module.exports = __webpack_public_path__ + "media/images/flags/1x1/sau-2db8946c28d9c7257fbf199640da7b22.svg";